<div class="clubs-list-card">
  <div class="card-header">
    <div class="header-left">
      <app-icon [type]="IconType.BUILDING" [size]="20"></app-icon>
      <h3 class="card-title">Meine Clubs</h3>
    </div>
  </div>

  <div class="card-content">
    @if (loading) {
      <div class="loading-state">
        @for (i of [1, 2]; track i) {
          <div class="skeleton-item">
            <div class="skeleton skeleton-icon"></div>
            <div class="skeleton skeleton-details"></div>
          </div>
        }
      </div>
    } @else if (organizations.length === 0) {
      <div class="empty-state">
        <app-icon [type]="IconType.BUILDING" [size]="40"></app-icon>
        <p class="empty-title">Noch kein Club</p>
        <p class="empty-subtitle">Tritt einem Club bei, um Plätze zu buchen</p>
      </div>
    } @else {
      <div class="clubs-list">
        @for (org of organizations; track org.organizationId) {
          <a class="club-item clickable" [routerLink]="getClubDetailLink(org.organizationId)">
            <div class="club-icon">
              <app-icon [type]="IconType.BUILDING" [size]="20"></app-icon>
            </div>
            <div class="club-details">
              <div class="title-row">
                <span class="club-name">{{ org.organizationName }}</span>
                <span [class]="getRoleBadgeClass(org.role)">
                  {{ getRoleLabel(org.role) }}
                </span>
              </div>
              <div class="club-meta">
                @if (getActiveMembershipsCount(org.organizationId) > 0) {
                  <span class="membership-info">
                    <app-icon [type]="IconType.CHECK" [size]="12"></app-icon>
                    {{ getMembershipsSummary(org.organizationId) }}
                  </span>
                } @else {
                  <span class="membership-info no-membership">
                    <app-icon [type]="IconType.INFO" [size]="12"></app-icon>
                    {{ getMembershipsSummary(org.organizationId) }}
                  </span>
                }
              </div>
            </div>
            <div class="club-action">
              <app-icon [type]="IconType.CHEVRON_RIGHT" [size]="20"></app-icon>
            </div>
          </a>
        }
      </div>
    }
  </div>
</div>
